<template lang="pug">
.content-center
  .overlay
  .back-btn.mb-2(@click="back()")
    i.fa-solid.fa-left-long
    |  {{ $t("ui.back") }} 
  template(v-if="$store.getters.language == 'cn'")
    cnContent
  template(v-else-if="$store.getters.language == 'vi'")
    //- viContent
    enContent
  template(v-else-if="$store.getters.language == 'th'")
    //- thContent
    enContent
  template(v-else-if="$store.getters.language == 'id'")
    idContent
  template(v-else-if="$store.getters.language == 'kr'")
    krContent
  template(v-else)
    enContent
</template>

<script>
import enContent from "@/components/mobile/rules/en/general-market";
import cnContent from "@/components/mobile/rules/cn/general-market";
import viContent from "@/components/mobile/rules/vi/general-market";
import thContent from "@/components/mobile/rules/th/general-market";
import idContent from "@/components/mobile/rules/id/general-market";
import krContent from "@/components/mobile/rules/kr/general-market";

export default {
  components: {
    enContent,
    cnContent,
    viContent,
    thContent,
    idContent,
    krContent
  },
  computed: {},
  methods: {
    back() {
      this.$router.push("/betting_rules");
    }
  }
};
</script>